// Central query-key factory so keys stay consistent between the components that
// read data and the mutations that invalidate it. Params are folded into the key
// so pagination/filter changes fetch (and cache) independently.
export const queryKeys = {
  currentUser: ['currentUser'],
  mentors: (params) => (params ? ['mentors', params] : ['mentors']),
  cohorts: (params) => (params ? ['cohorts', params] : ['cohorts']),

  // Admin — sessions
  adminCoachingSessions: (params) => ['admin', 'coaching-sessions', params ?? {}],
  adminCoachingSessionsStats: ['admin', 'coaching-sessions', 'stats'],
  adminPeerSessions: (params) => ['admin', 'peer-sessions', params ?? {}],
  adminPeerSessionsStats: ['admin', 'peer-sessions', 'stats'],
  adminPeerProfiles: (params) => ['admin', 'peer-profiles', params ?? {}],
  adminPeerProfilesStats: ['admin', 'peer-profiles', 'stats'],

  // Admin — payouts
  adminPayouts: (params) => ['admin', 'payouts', params ?? {}],
  adminPayoutsStats: ['admin', 'payouts', 'stats'],

  // CRM
  crmDashboard: (params) => ['crm', 'dashboard', params ?? {}],
};
